import LandingFrame from './LandingFrame';
import autoDmHtml from '../../../public/landing/autodm.html?raw';

const AutoDm = () => <LandingFrame html={autoDmHtml} title="소셜듀오 자동 DM" />;

export default AutoDm;
